module.exports = __webpack_public_path__ + "img/20m9.3e8aff6e.jpg";